import { Site } from '@envato/foundation-types'
import get from 'lodash-es/get'
import * as React from 'react'

import itemSmallPreviewUrl from '../../../common/utils/itemSmallPreviewUrl'
import { getCurrentSiteFromDomain } from '../../../common/utils/sites'
import AudioPreviewer from '../audioPreviewer'
import DefaultItemPreviewer from '../itemCard/defaultItemPreviewer'
import MagnifierConfigurator from '../magnifier/configurator'
import Overlay from '../overlay'

import { IItem } from '../../../typings/searchResults'

import * as styles from './index.module.css'

const ItemPreviewer = ({
  item,
  annotation,
  videoMuted,
  muteVideo,
  onClick,
  nonSquare = false,
  lazyLoad = false
}: {
  item: IItem
  annotation?: string
  videoMuted: boolean
  muteVideo: () => void
  onClick?: () => void
  nonSquare?: boolean
  lazyLoad?: boolean
}) => {
  const itemSite = getCurrentSiteFromDomain(item.site)
  const nonSquareImageUrl = get(item, 'previews.thumbnail_preview.small_url')
  const smallPreviewUrl = itemSmallPreviewUrl(item)
  const previewUrl = nonSquare ? nonSquareImageUrl : smallPreviewUrl

  const itemPreviewer =
    itemSite === Site.audiojungle ? (
      <AudioPreviewer
        imageUrl={smallPreviewUrl}
        audioUrl={get(item, 'previews.icon_with_audio_preview.mp3_url')}
        url={item.url}
        isTrending={item.trending}
        name={item.name}
        onClick={onClick}
        rank={0}
        lazyLoad={lazyLoad}
      />
    ) : (
      <DefaultItemPreviewer
        url={item.url}
        name={item.name}
        imageUrl={previewUrl}
        onClick={onClick}
        isSquareImage={!nonSquare}
        lazyLoad={lazyLoad}
      />
    )

  const overlayContent = (
    <div className={styles.magnifier}>
      <MagnifierConfigurator
        item={item}
        videoMuted={videoMuted}
        muteVideo={muteVideo}
      />
    </div>
  )

  return (
    <div>
      <Overlay position="side" content={overlayContent}>
        {itemPreviewer}
      </Overlay>
      {annotation && <small className={styles.annotation}>{annotation}</small>}
    </div>
  )
}

export default ItemPreviewer
